import React from "react";
import { ArrowUpRight } from "lucide-react";
import { DiscordLogo } from '../SocialIcons';
import { Button } from "../ui/button";
import { REWARDS_DISCORD_URL } from "../../content/rewards";

export const VipClaimBanner = () => (
  <section className="vip-claim-banner glass" aria-labelledby="vip-claim-title" data-testid="vip-claim-banner">
    <span className="vip-claim-symbol" aria-hidden="true" data-testid="vip-claim-discord-logo"><DiscordLogo width={25} height={25} /></span>
    <div className="vip-claim-copy">
      <h2 id="vip-claim-title" className="font-display text-base md:text-lg font-bold" data-testid="vip-claim-title">Claim your rewards</h2>
      <p data-testid="vip-claim-description">To claim any reward, join our Discord and create a ticket.</p>
    </div>
    <Button asChild className="vip-signup-button">
      <a href={REWARDS_DISCORD_URL} target="_blank" rel="noopener noreferrer" data-testid="vip-join-discord">Join Discord<ArrowUpRight size={17} aria-hidden="true" /></a>
    </Button>
  </section>
);